import { api, authorizationKey, BASE_URL } from "./BASE_URL";

export const fetchMessages = async (type) => {
  try {
    const url = new URL(`${BASE_URL}/admin/messages`);
    if (type) {
      url.searchParams.append("type", type);
    }
    const response = await api.get(url, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching messages:", err);
    throw err;
  }
};

export const parseMessage = async (message_id, lead_id, type) => {
  try {
    const url = new URL(`${BASE_URL}/admin/messages/parse`);

    if (message_id) {
      url.searchParams.append("message_id", message_id);
    }
    if (lead_id) {
      url.searchParams.append("lead_id", lead_id);
    }
    if (type) {
      url.searchParams.append("type", type);
    }

    const response = await api.get(url, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching messages:", err);
    throw err;
  }
};

export const postMessage = async (title, text, type) => {
  try {
    const url = new URL(`${BASE_URL}/admin/messages`);
    if (type) {
      url.searchParams.append("type", type);
    }

    const response = await api.post(
      url,
      {
        title,
        text,
      },
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data?.data;
  } catch (err) {
    console.error("Error posting message:", err);
    throw err;
  }
};

export const updateMessage = async (id, payload, type) => {
  console.log(id, payload, type);
  try {
    const url = new URL(`${BASE_URL}/admin/messages/${id}`);
    if (type) {
      url.searchParams.append("type", type);
    }
    const response = await api.put(url, payload, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data?.data;
  } catch (err) {
    console.error("Error udpating message:", err);
    throw err;
  }
};

export const deleteMessage = async (id) => {
  try {
    const response = await api.delete(`${BASE_URL}/admin/messages/${id}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data?.data;
  } catch (err) {
    console.error("Error udpating message:", err);
    throw err;
  }
};

export const sendMessageToUser = async (payload) => {
  try {
    const response = await api.post(
      `${BASE_URL}/admin/contacts-send-sms`,
      payload,
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data?.data;
  } catch (err) {
    console.error("Error sending message:", err);
    throw err;
  }
};

export const fetchLogs = async ({
  page,
  phone,
  message_id,
  startDate,
  endDate,
}) => {
  const url = new URL(`${BASE_URL}/admin/messages/log`);

  if (page) {
    url.searchParams.append("page", page);
  }

  if (phone) {
    url.searchParams.append("phone", phone);
  }

  if (message_id) {
    url.searchParams.append("message_id", message_id);
  }

  if (startDate) {
    url.searchParams.append("start_at", startDate);
  }

  if (endDate) {
    url.searchParams.append("end_at", endDate);
  }

  try {
    const response = await api.get(url, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching messages logs:", err);
    throw err;
  }
};
